import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import { isDeepEquals } from "../../../utils/isDeepEquals";

export default function ReactMultiSelect(props) {
  const [listToDisplay, setListToDisplay] = useState(props.listToDisplay);
  const selectedList = props.selectedList || [];

  // Filter out any existing "Select All" options from the data
  const optionsToDisplay = listToDisplay.filter(
    (item) =>
      !item.isSelectAll && item.value !== "*" && item.label !== "Select All"
  );

  useEffect(() => {
    if (!isDeepEquals(props.listToDisplay, listToDisplay)) {
      setListToDisplay(props.listToDisplay);
    }
  }, [props.listToDisplay]);

  const handleChange = (val) => {
    props.handleSelectedListCallback([...val]);
  };

  return (
    <div
      className={
        selectedList.length > 0 ? "" : "react-select-carrier-container"
      }
      style={props.style}
    >
      <MultiSelect
        className="react-select-checkbox"
        classNamePrefix="react-select-checkbox"
        options={optionsToDisplay} // Use filtered options
        value={selectedList}
        onChange={handleChange}
        labelledBy="Select"
        hasSelectAll={true} // Keep the working built-in select all
        selectAllLabel="Select All"
        clearable={true}
        disableSearch={false}
        ClearSelectedIcon={null}
        ClearIcon={null}
        // getDropdownButtonLabel={() => {
        //   const count = optionsToDisplay.length;
        //   const totalCount = optionsToDisplay.length; // Use filtered count

        //   if (count === 0) return "Select";
        //   // if (count === totalCount && totalCount > 0) return "All selected";
        //   return `${count} selected`;
        // }}
        // valueRenderer={() => {
        //   const count = optionsToDisplay.length;
        //   const totalCount = optionsToDisplay.length; // Use filtered count

        //   if (count === 0) return "Select";
        //   // if (count === totalCount && totalCount > 0) return "All selected";
        //   return `${count} selected`;
        // }}
        onClearAll={() => {
          props.handleSelectedListCallback([]);
        }}
        getDropdownButtonLabel={() => {
          const selectedCount = selectedList.length;
          const totalCount = optionsToDisplay.length;

          if (selectedCount === 0) return "Select";
          if (selectedCount === totalCount && totalCount > 0)
            return "All selected";
          return `${selectedCount} selected`;
        }}
        valueRenderer={() => {
          const selectedCount = selectedList.length;
          const totalCount = optionsToDisplay.length;

          if (selectedCount === 0) return "Select";
          if (selectedCount === totalCount && totalCount > 0)
            return "All selected";
          return `${selectedCount} selected`;
        }}
      />
    </div>
  );
}
